import { makeObservable, observable, runInAction } from 'mobx';
import { IOAuthConnection } from '../models/oauth-refresh-token.model';
import connectionService from '../services/connection/connection.service';
import { getLogger } from '../services/logger.service';

const log = getLogger('McpConnectionsStore');

export class McpConnectionsStore {
  connections: IOAuthConnection[] = [];
  loading = false;

  constructor() {
    makeObservable(this, {
      connections: observable,
      loading: observable,
    });
  }

  async load() {
    runInAction(() => { this.loading = true; });
    try {
      const conns = await connectionService.getOAuthConnections();
      runInAction(() => { this.connections = conns; });
    }
    catch (e) {
      log.e('Failed to load OAuth connections', e);
    }
    finally {
      runInAction(() => { this.loading = false; });
    }
  }

  async revoke(connectionId: string) {
    await connectionService.deleteOAuthConnection(connectionId);
    runInAction(() => {
      this.connections = this.connections.filter(c => c._id !== connectionId);
    });
  }
}

export default new McpConnectionsStore();
